import clsx from 'clsx'

import Creator from '@/ts/Creator'

import Avatar from './includes/Avatar'
import Description from './includes/Description'
import Heading from './includes/Heading'
import SocialMedia from './includes/SocialMedia'
import css from './Profile.module.scss'

function Profile({ creator }: { creator: Creator }) {
  const { avatar, description, nickname, category, social_media } = creator

  return (
    <div className="border-b-2 box border-violet-5">
      <div className={clsx(css['content'])}>
        <div className={clsx(css['avatar'])}>
          <Avatar nickname={nickname} src={avatar} />
        </div>
        <div className={clsx(css['heading'])}>
          <Heading nickname={nickname} category={category?.name} />
        </div>
        <div className={clsx(css['description'])}>
          <Description value={description} />
          <SocialMedia media={social_media} />
        </div>
      </div>
    </div>
  )
}

export default Profile
